import React, { useState, useCallback, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { CssBaseline, Snackbar, Alert, AlertTitle } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { format } from 'date-fns';

import theme from './theme';
import Header from './components/Header';
import MainRouter from './MainRouter';
import axiosInstance from './axiosConfig';            // ← NUEVO

/* ───────── Config react-query ───────── */
const queryClient = new QueryClient();

const App = () => {
  /* ----------  estado sesión ---------- */
  const [token,   setToken]   = useState(sessionStorage.getItem('token'));
  const [nombre,  setNombre]  = useState(sessionStorage.getItem('nombre'));
  const [rol,     setRol]     = useState(sessionStorage.getItem('rol'));

  /* ----------  alertas ---------- */
  const [alertaVisible, setAlertaVisible] = useState(false);
  const [alertaTipo,    setAlertaTipo]    = useState('');
  const [alertaMensaje, setAlertaMensaje] = useState('');

  /* ----------  útil ---------- */
  const fechaHoy = format(new Date(), 'yyyy-MM-dd');

  /* ================================================================
     PETICIÓN PARA SABER EL ROL SEGÚN API
  ================================================================= */
  const fetchRol = async (nombreUsuario) => {
    try {
      const { data } = await axiosInstance.get(`/usuarios/rol/${nombreUsuario}`);
      return data?.rol || null;
    } catch (err) {
      console.error('Error obteniendo rol:', err);
      return null;   // fallback ⇒ se controlará abajo
    }
  };

  /* ================================================================
     LOGIN
  ================================================================= */
  const handleLogin = useCallback(async (tokenBack, nombreBack) => {
    /* 1) Guardar token/nombre */
    setToken(tokenBack);
    setNombre(nombreBack);
    sessionStorage.setItem('token',  tokenBack);
    sessionStorage.setItem('nombre', nombreBack);

    /* 2)  Consultar rol    */
    let rolObtenido = await fetchRol(nombreBack);

    setRol(rolObtenido);
    sessionStorage.setItem('rol', rolObtenido);
  }, []);

  /* ================================================================
     LOGOUT
  ================================================================= */
  const handleLogout = useCallback(() => {
    setToken(null);
    setNombre(null);
    setRol(null);
    sessionStorage.clear();
  }, []);

  /* ================================================================
     ALERTAS
  ================================================================= */
  const showAlert = useCallback((tipo, mensaje) => {
    setAlertaTipo(tipo);
    setAlertaMensaje(mensaje);
    setAlertaVisible(true);
  }, []);

  const handleCloseAlert = () => setAlertaVisible(false);

  /* ================================================================
     Restaurar rol si hay sesión guardada pero falta “rol” (refresh)
  ================================================================= */
  useEffect(() => {
    const recuperarRol = async () => {
      if (token && nombre && !rol) {
        const r = await fetchRol(nombre);
        if (r) {
          setRol(r);
          sessionStorage.setItem('rol', r);
        }
      }
    };
    recuperarRol();
  }, [token, nombre, rol]);

  /* ================================================================
     RENDER
  ================================================================= */
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />

        <Router>
         {token && <Header rol={rol} handleLogout={handleLogout} />}
          <div className="main-content">
            <MainRouter
              token={token}
              rol={rol}
              handleLogin={handleLogin}
              fechaHoy={fechaHoy}
              showAlert={showAlert}          /* por si lo necesitas */
            />
          </div>

          <Snackbar
            open={alertaVisible}
            autoHideDuration={6000}
            onClose={handleCloseAlert}
          >
            <Alert
              onClose={handleCloseAlert}
              severity={alertaTipo || 'error'}
            >
              <AlertTitle>
                {alertaTipo === 'success' ? '¡Éxito!' : 'Error'}
              </AlertTitle>
              {alertaMensaje || 'No hay mensaje disponible'}
            </Alert>
          </Snackbar>
        </Router>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
